import React from 'react'; // eslint-disable-line

import t from '../../../theme/admin/adminStyles';

/** @jsxImportSource @emotion/react */

export const AdminPauseIcon = (props: object) => {
  return (
    <svg role="img" aria-labelledby="pauseIconTitleID" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <title id="pauseIconTitleID">Pause Icon</title>
      <rect x="9" y="4" width="1" height="16" css={[t.fill_current]} />
      <rect x="14" y="4" width="1" height="16" css={[t.fill_current]} />
    </svg>
  );
};
